/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import {defineStyleConfig} from '@chakra-ui/styled-system';

export default defineStyleConfig({
  baseStyle: ({theme, presets = [], options = {}}) => ({
    position: 'relative',
    overflow: 'hidden',
    backgroundColor: 'black',

    sx: {
      '&.readonly, &[readonly]': {
        pointerEvents: 'none',
      },

      '> iframe, > img': {
        position: 'absolute',
        margin: 0,
      },

      '> iframe[data-ready="true"]': {
        backgroundColor: 'black',
      },

      '&.square > img, &.square > iframe': {
        top: '50%',
        left: '50%',
      },

      '&.landscape > img, &.landscape > iframe': {
        top: 0,
        left: '50%',
        width: 'auto',
        height: '100%',
      },

      '&.portrait > img, &.portrait > iframe': {
        top: '50%',
        left: 0,
        width: '100%',
        height: 'auto',
      },

      '&.aspect-ratio > iframe, &.aspect-ratio > img': {
        transform: 'unset',
      },

      '&.aspect-ratio > video': {
        width: '100% !important',
        height: '100% !important',
        left: '0 !important',
        top: '0 !important',
      },
    },
  }),
});
